module.exports = "//img1.rrcimg.com/_next/static/src/assets/tj_1mOXL.png";